export default __webpack_public_path__ + "static/media/bell-pepper-before.0928b3c7.png";